import "./AutomationRecipes.module.css";
import Navigation from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import LArteDellaCattura from "./sections/LArteDellaCattura";
import Features from "./sections/Features";
import Footer from "@/reusable_sections/Footer";
export default function AutomationRecipesPage() {
  return <div>
      <Navigation />
      <AboutHero />
      <LArteDellaCattura />
      <Features />
      <Footer />
    </div>;
}